@use '@fukuri-admins/ui/layout' as *;

.tableRow {
  transition: background-color 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background-color: $WhiteHover;
  }
}

.tableCell {
  line-height: 54px;
  font-size: 16px !important;
  font-weight: normal;
  border-bottom: 1px solid $Border;

  &.MuiTableCell-root {
    padding: 0;
  }
}

.emptyTable {
  font-size: 40px;
  color: $NATURAL_400;
  text-align: center;
  margin: 100px auto;
  height: 326px;
}

.link {
  color: #007bff; // 青色（Bootstrap風）
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: text("Disabled");
    cursor: not-allowed;
    text-decoration: none;
  }
}

.centerAlign {
  text-align: center;
}

.modalContent {
  padding: 40px;
  background-color: white;
  border-radius: 8px;
  max-width: 650px;
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  .modalTitle {
    text-align: center;
    font-size: 28px;
    padding: 10px;
  }

  .modalDescription {
    margin-bottom: 8px;
    color: #767779;
  }

  .errorMessage {
    color: red;
    font-family: "Noto Sans JP"; //20230111
    font-weight: 800;
    font-size: 14px;
    line-height: 22px;
    text-align: left;
  }

  .btnContainer {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;

    @media (max-width: 570px) {
      display: block;
    }
  }
}
